<template>
    <div>
        <PromotionHistory
            v-if="type == 'history'"
            :modalController="modalController"
        ></PromotionHistory>
        <template v-else>
            <PromotionItem
                v-for="(item, idx) of items"
                :key="`hot-promotion-${idx}`"
                :campaign="item"
                @onClickItem="onClickItem($event)"
            ></PromotionItem>
            <div
                class="text-center mt-7 text-sm"
                v-if="!items.length"
                v-html="lbl.promotion.comingSoon"
            ></div>
        </template>
    </div>
</template>

<script>
import PromotionItem from "./PromotionItem.vue";
import PromotionHistory from "@/module/Promotion/SpecialForYou/component/PromotionHistory.vue";
// mixins
import LocaleMixin from "@/mixin/LocaleMixin";

export default {
    name: "PromotionList",
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
            default: "",
        },
        modalController: {
            type: Object,
            default: null,
        },
    },
    components: {
        PromotionItem,
        PromotionHistory,
    },
    emits: ["onClickItem", "onClickPurchase", "onClickSlip"],
    mixins: [LocaleMixin],
    methods: {
        onClickItem: function (item) {
            this.$emit("onClickItem", item);
        },
        clickPurchase: function (purchase) {
            this.$emit("onClickPurchase", purchase);
        },
        clickSlip: function(purchase){
            this.$emit("onClickSlip", purchase)
        }
    },
};
</script>
